import Events from "./Utils/EventLite";

import Page from "./views/Page";
import Title from "./views/Title";
import Results from "./views/Results";
import Voting from "./views/Voting";
import StoryPanel from "./views/StoryPanel";
import Conclusion from "./views/Conclusion";

export default class Main {
    constructor(){
        this.element = document.body;
        this.setupPages();
        this.currentPage = null;
        Events.on("goto", this.goto.bind(this));
        Events.on("resize", this.resize)
    }
    setupPages() {
        new Title();
        new StoryPanel("Story", {
                prevLabel: "Back to Title", 
                prev: "Title", 
                nextLabel: "Choose a pumpkin.",
                next: "Voting", 
                altPrevLabel: "Back to Title",
                altPrev: "Title",
                altNextLabel: "Finish the story.",
                altNext: "StoryComplete"
            });
        new Results();
        new Voting();
        new Conclusion("StoryComplete", {
                prevLabel: "View the story.",
                prev:"Story", 
                nextLabel: "See the Results.",
                next:"Results",
                altPrevLabel: "View the story.",
                altPrev:"Story", 
                altNextLabel: "See the Results.",
                altNext:"Results"});
        this.addPages();
    }
    addPages() {
        var pages = Page.getPages();
        var parent = this.element;
        for (var page in pages) {
            parent.appendChild(pages[page].element);
        }
    }
    goto (pageId) {
        ga('send', 'pageview','Navigate',pageId);
        var page = Page.getPage(pageId);
        if(this.currentPage != null) {
            new Promise(this.currentPage.close.bind(this.currentPage))
                 .then(page.init.bind(page))
                 .then(function(){
                this.currentPage = page;
            }.bind(this));
        } else {
            new Promise(page.init.bind(page)).then(function(){
                this.currentPage = page;
            }.bind(this));
        }
    }
    resize (e) {
        
    }
}



// WEBPACK FOOTER //
// ./src/Main.js